import React, { useCallback, useState } from 'react'
import { get, pick } from 'lodash-es'
import { ErrorBoundary } from 'react-error-boundary'
import {
  TbViewProvider,
  useTbViewStore,
  useFetchRemoteData,
  useBeforeTransform,
  useProjectStore,
} from '@vt/hooks'
import { ModalsProvider } from '@mantine/modals'
import { DittoProvider } from '@ow/ditto-core'
import { upload, addWatermarkToImage } from '@vt/apis/lib-ex/v2/givrali'
import styled from '@emotion/styled'
import { ResizableBox } from 'react-resizable'
import NavMenu from '../container/container-render/NavMenuOperate'
import ContainerRender from '../container/container-render'
// import Status from '../container/container-render/Status'
import Areas from '../container/container-render/Areas'
import TreeSelect from '../container/container-render/TreeSelect'
import BatchOperate from '../triggers/review'
import DataOperateProvider from '../data-operate/DataOperateProvider'

const StyledResizableBox = styled(ResizableBox)`
  position: relative;

  .react-resizable-handle {
    position: absolute;
    width: 10px;
    height: 100%;
    right: 0;
    top: 0;
    cursor: e-resize;
    z-index: 1;
  }
`

// const showDataTypes = ['list', 'calendar', 'article', 'file', 'map']

/**
 * ViewInspect用于单独展示主体部分带侧边栏（area）的布局
 * 视图部分对应layouts.inspect，配置为[]或[{type: 'area'}]
 * 原因：之前status单独在此布局写死，改为了通过在layouts.layouts里配置type:status的布局，
 * 通过代码方式抽取到顶部以 100%宽度 展示
 * TODO: 这部分的area逐步迁移成通用配置（边栏及拖拽宽度），形如list / article等部分的的配置，这样
 * TODO: 可以将area作为普通布局来完成，同时status也作为普通配置来做
 * TODO: 左侧的areas会用通用的treeSelect替换
 * @returns
 */
const ViewContentRender = function () {
  const [width, setWidth] = useState(200)
  const {
    layouts,
    showRecycle,

    // freshTbDataByIds,
    isShowBatchOperate,
  } = useTbViewStore((state) =>
    pick(state, [
      'layouts',
      'showRecycle',

      // 'freshTbDataByIds',
      'isShowBatchOperate',
    ])
  )

  const showLayouts = showRecycle ? layouts.recycleLayouts : layouts.layouts
  console.log(showLayouts, 'showLayouts')

  const inspectElements = get(layouts, 'inspect.elements', [])
  // const showAreas =
  //   inspectElements.length !== 0 && inspectElements[0].leftElements.length !== 0

  // inspect的内容最多为status / area+table两栏。考虑兼容
  // 如果只有一个，默认显示内容area+table。如果有多个，判断是否自定义status，有就显示
  let statusPart = {
    // 兼容无配置的页面
    leftElements: [{ type: 'status' }],
    rightElements: [
      {
        type: 'linkButton',
        actionType: 'batchStatus',
      },
    ],
  }

  // 将layouts的status栏移动到顶部
  const elements = showLayouts.elements.filter((elem) => {
    if (
      elem.leftElements &&
      elem.leftElements.find((lElem) => lElem.type === 'status')
    ) {
      statusPart = elem
      return false
    }
    return true
  })

  const normalPart =
    inspectElements && inspectElements.length > 0 ? inspectElements[0] : {}
  const leftSelectNode =
    normalPart.leftElements &&
    normalPart.leftElements.find((lElem) => lElem.type)

  const onResize = (event, { size }) => {
    setWidth(size.width)
  }

  return (
    <DataOperateProvider>
      <div
        className="h-full flex flex-col overflow-hidden flex-1"
        style={{ margin: '14px', gap: '14px' }}
      >
        <NavMenu layouts={showLayouts && showLayouts.navMenu} />

        {!statusPart.hidden && (
          <div className="flex flex-col gap-2">
            <ErrorBoundary fallback={<div>layouts渲染错误</div>}>
              <ContainerRender
                styles={{ padding: '0 15px 0 0' }}
                key={`${statusPart}`}
                layouts={statusPart}
              />
            </ErrorBoundary>
          </div>
        )}

        <div className="flex gap-2 flex-1 overflow-hidden">
          {leftSelectNode && (
            <StyledResizableBox
              width={width}
              height={Infinity}
              minConstraints={[200, Infinity]}
              maxConstraints={[500, Infinity]}
              onResize={onResize}
              axis="x"
              className="customResizable"
            >
              <div className="flex h-full bg-white px-4 text-sm">
                {leftSelectNode.type === 'area' ? (
                  <Areas />
                ) : (
                  <TreeSelect type={leftSelectNode.type} />
                )}
              </div>
            </StyledResizableBox>
          )}
          <div className="flex flex-col gap-2 h-full flex-1">
            <ErrorBoundary fallback={<div>layouts渲染错误</div>}>
              {(elements || [])
                .filter((element) => !element.hidden)
                .map((element, i) => {
                  return (
                    <ContainerRender
                      key={`${element}-${i}`}
                      layouts={element}
                    />
                  )
                })}
            </ErrorBoundary>
          </div>
          {isShowBatchOperate && (
            <div className="flex flex-col gap-2 h-full bg-white">
              <BatchOperate />
            </div>
          )}
        </div>
      </div>
    </DataOperateProvider>
  )
}

const TbViewbasic = function ({
  appId,
  tbId,
  vid,
  customExtendsStore,
  children,
}) {
  const fetchRemoteData = useFetchRemoteData()
  const { customCompsMap } = useProjectStore((state) =>
    pick(state, ['customCompsMap'])
  )
  const extendsStore = useCallback((set, _get, state = {}) => {
    function extend() {
      const setCurrentStatus = (currentStatus) => {
        set(() => ({ currentStatus }))
      }
      const setIsShowBatchOperate = (isShowBatchOperate) => {
        set(() => ({ isShowBatchOperate }))
      }

      const setRefreshStatus = (refreshStatus) => {
        set(() => ({ refreshStatus }))
      }

      return {
        inspectInited: true,
        setCurrentStatus,
        /** 是否显示批量操作组件 */
        isShowBatchOperate: false,
        setIsShowBatchOperate,
        currentStatus: [],
        refreshStatus: false,
        setRefreshStatus,
      }
    }

    if (!state.inspectInited) {
      return extend()
    }
    return {}
  }, [])

  const beforeTransform =
    customCompsMap && customCompsMap.useBeforeTransform
      ? customCompsMap.useBeforeTransform
      : useBeforeTransform
  return (
    <DittoProvider
      tbId={tbId}
      onFetchRemoteData={fetchRemoteData}
      upload={upload}
      addWatermarkToImage={addWatermarkToImage}
      beforeTransform={beforeTransform}
    >
      <TbViewProvider
        appId={appId}
        tbId={tbId}
        vid={vid}
        extendsStore={customExtendsStore || extendsStore}
      >
        <ModalsProvider>{children}</ModalsProvider>
        <ViewContentRender />
      </TbViewProvider>
    </DittoProvider>
  )
}

export default TbViewbasic
